define('services/loggingService',[
    'lib/lodash4',
    'lib/knockout',
    'config',
    'services/localLogger',
    'services/serverLogger'
], function (_, ko, config, localLogger, serverLogger) {
    'use strict';

    var
        logLevelSettings = ['none', 'error', 'warn', 'info', 'debug', 'trace'],
        loggingService = {
            localLogLevel: ko.observable(config.localLogLevel || 'none'),
            serverLogLevel: ko.observable(config.serverLogLevel || 'error')
        };
        var turnLoggerOff = (config.loggedNamespaces || []).length > 0;

    /**
     * Given a list of functions, return a function that will delegate to
     * each function in that list, or perform a noop if the list is empty.
     * Used to build log methods for each level.
     */
    function allOrNoop(functions) {
        if (functions.length === 0 || turnLoggerOff) {
            return _.noop;
        } else if (functions.length === 1) {
            return functions[0];
        } else {
            return function () {
                for (var i=0; i < functions.length; i++) {
                    functions[i].apply(this, arguments);
                }
            };
        }
    }

    ko.computed(function () {
        var settableLogLevels = _(logLevelSettings).without('none').valueOf();
        var localLogLevelIdx = settableLogLevels.indexOf(loggingService.localLogLevel().toLowerCase());
        var serverLogLevelIdx = settableLogLevels.indexOf(loggingService.serverLogLevel().toLowerCase());

        for (var i = 0; i < settableLogLevels.length; i++) {
            var logLevel = settableLogLevels[i];
            var logFunctions = [];

            if (i <= localLogLevelIdx) {
                logFunctions.push(localLogger[logLevel]);
            }
            if (i <= serverLogLevelIdx) {
                logFunctions.push(serverLogger[logLevel]);
            }

            loggingService[logLevel] = allOrNoop(logFunctions);
        }
    });

    return loggingService;
});

